import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiData, getApiRecord } from 'services/ExtraChargeService'

export const getData = createAsyncThunk(
    'extraCharges/data/getData',
    async (data) => {
        const response = await getApiData(data)
        return response.data
    },
)

export const getRecord = createAsyncThunk(
    'extraCharges/data/getRecord',
    async (id) => {
        const response = await getApiRecord(id)
        const data = {
            ...response.data,
            company: parseInt(response.data?.assignment?.company_id),
            client: response.data?.assignment?.client_id,
            transport_provider: response.data.assignment.transport_provider,
            service: response.data.assignment.service,
        }
        return data
    },
)

const recordData = {
    company: '',
    client: '',
    transport_provider: '',
    service: '',
    fee_code: '',
    fee_description: '',
    buy_fee_applies_to: '',
    sell_fee_applies_to: '',
    charge_value: '',
    start_date: '',
    end_date: '',
    type: '',
    is_fuel_levy_exempt: '',
}

const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    query: '',
    selectedTab: '',
    service: '',
    sort: [{ column: '', dir: '' }],
}

const dataSlice = createSlice({
    name: 'extraCharges/data',
    initialState: {
        loading: false,
        view: recordData,
        data: [],
        tableData: initialTableData,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.tableData = payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getData.pending, (state) => {
                state.loading = true
                state.tableData.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload?.results
                state.tableData.total = payload?.count
            })
            .addCase(getData.rejected, (state) => {
                state.loading = false
                state.data = []
            })
            .addCase(getRecord.fulfilled, (state, { payload }) => {
                state.loading = false
                state.record = payload
            })
            .addCase(getRecord.pending, (state) => {
                state.loading = true
                state.record = null
            })
            .addCase(getRecord.rejected, (state) => {
                state.loading = false
                state.record = null
            })
    },
})

export const { setData, setTableData } = dataSlice.actions

export default dataSlice.reducer
